import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import BCXFormValues from '@/components/molecules/forms/BCXFormValues.vue';
import { BcxFormValueField } from '@/models/BcxForm';
import useI18n from '@/mixins/useI18n';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePaymentDataDisplay',
  props: {
  paymentData: {
    type: Object as PropType<any>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const { t } = useI18n();
const { isMobileWidth } = useResponsiveness();

const horizontalGap = isMobileWidth.value ? '16px' : '40px';

const displayedPaymentData = computed(() => {
  const {
    institute, bic, iban, vat, reverseCharge, currency, ...rest
  } = props.paymentData;
  return {
    ...rest,
    vat: `${vat} %`,
    reverseCharge: `${t(`invoice.payment-data.reverseChargeOptions.${reverseCharge}`)}`,
    currency: `${t(`invoice.payment-data.currencyOptions.${currency}`)}`,
    account: {
      institute, bic, iban
    }
  };
});

const baseFields = computed(() => {
  const fields:BcxFormValueField[] = [
    {
      name: 'account',
      width: '67%',
      label: `${t('invoice.payment-data.form.account')}`,
    },
    {
      name: 'currency',
      width: '33%',
      label: `${t('invoice.payment-data.form.currency')}`,
    }
  ];
  return fields;
});

const taxFields = computed(() => {
  const fields:BcxFormValueField[] = [
    {
      name: 'vatId',
      width: isMobileWidth.value ? '50%' : '33%',
      label: `${t('invoice.payment-data.form.vatId')}`,
    },
    {
      name: 'vat',
      width: isMobileWidth.value ? '50%' : '34%',
      label: `${t('invoice.payment-data.form.vat')}`,
    },
    {
      name: 'reverseCharge',
      width: isMobileWidth.value ? '100%' : '33%',
      label: `${t('invoice.payment-data.form.reverseCharge')}`,
    }
  ];
  return fields;
});


return { __sfc: true,props, t, isMobileWidth, horizontalGap, displayedPaymentData, baseFields, taxFields, BCXFormValues }
}

})